import { z } from 'zod';
import { ID } from '../../utils/codecUtils';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { documentSchema } from '../models/document.schema';
import { documentsListQuerySchema } from './list.schema';

export type DocumentsListQuery = {
  id?: ID | ID[];
  email?: ID | ID[];
  creator?: string;
  arrivedAt?: string;
  createdAt?: string;
  originalFileName?: string;
  attachmentStatus?: string;
  ordering?: '-attachment_status' | undefined;
} & PaginationQuery;

export const list = (query: DocumentsListQuery = {}) => {
  return {
    endpoint: `/documents`,
    method: 'GET',
    responseSchema: listResponse(documentSchema),
    query: { ...query, includeTotal: true },
    querySchema: documentsListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
